// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"67688547","563":"48954655","590":"5b155198","688":"02859402","810":"034caafe","847":"f4907b4c","983":"599a9b84"}[chunkId] + ".chunk.js";
};